<template>
  <section class="roboverse-eleventh-section">
    <div
      class="headline"
      data-aos="fade-right"
      data-aos-easing="ease-out-cubic"
      data-aos-offset="0"
      data-aos-delay="100"
      data-aos-duration="1000"
      data-aos-once="true"
    >
      <h1 class="bg-text">ROBOVERSE</h1>
      <h2 class="title">{{ $t("verse.section11.title") }}</h2>
    </div>

    <div
      class="galaxy-text"
      data-aos="fade-up"
      data-aos-easing="ease-out-cubic"
      data-aos-offset="0"
      data-aos-delay="100"
      data-aos-duration="1000"
      data-aos-once="true"
    ></div>

    <div
      class="more"
      data-aos="fade-up"
      data-aos-easing="ease-out-cubic"
      data-aos-offset="0"
      data-aos-delay="300"
      data-aos-duration="1000"
      data-aos-once="true"
      @click="moreClick"
    >
      {{ $t("verse.section11.learnMore") }}>
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "RoboverseEleventhSection",

  computed: {
    ...mapState("app", {
      locale: (state) => state.locale,
    }),
  },

  methods: {
    moreClick() {
      this.$router.push({ name: "RoboGalaxy" });
    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/assets/css/font.css";
@import "~@/assets/css/image.less";
.roboverse-eleventh-section {
  position: relative;
  padding-bottom: 1.5rem;

  .headline {
    padding-top: 1.1rem;
    margin-left: 1.5rem;
    h1,
    h2 {
      margin: 0;
      padding: 0;
    }
    .bg-text {
      font-family: "HarmonyOS Sans SC Bold";
      font-style: normal;
      font-weight: 700;
      font-size: 0.32rem;
      line-height: 0.45rem;
      letter-spacing: 0.01em;
      text-transform: uppercase;
      background: linear-gradient(
        98.62deg,
        #364242 3.92%,
        #2b2f37 48.34%,
        #21262b 96.58%
      );
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      text-fill-color: transparent;
    }

    .title {
      font-family: "HarmonyOS Sans SC Bold";
      font-style: normal;
      font-weight: 900;
      font-size: 0.28rem;
      line-height: 0.33rem;
      letter-spacing: 0.065em;
      color: #00ff00;
    }
  }

  .galaxy-text {
    margin: 0.98rem auto 0.36rem auto;
    width: 7.95rem;
    height: 1.46rem;
    background-image: url("@{galaxyTxtImg}");
    background-size: contain;
    background-repeat: no-repeat;
  }

  .more {
    font-family: "HarmonyOS Sans SC";
    font-style: normal;
    font-weight: 400;
    font-size: 0.2rem;
    line-height: 0.22rem;
    letter-spacing: 0.6em;
    color: #00ff00;
    text-align: center;
    cursor: pointer;

    &:hover {
      font-size: 0.22rem;
    }
  }
}

@media only screen and (max-width: 750px) {
  .roboverse-eleventh-section {
    .headline {
      padding-top: 0.9rem;
      margin-left: 0.73rem;
    }

    .galaxy-text {
      margin: 0.98rem auto 0.19rem auto;
      width: 6.02rem;
      height: 1.46rem;
      background-size: contain;
      background-repeat: no-repeat;
    }
  }
}
</style>
